class Header {
    constructor() {
        console.log('Header.constructor');

        this.hasMobileSubnavigation = false;

        this.root = document.getElementsByTagName('html')[0];
        this.element = document.getElementsByClassName('header-static')[0];
        this.btn = this.element.getElementsByClassName('btn-open-submenu')[0];

        this.btnClickHandler = this.btnClickHandler.bind(this);
        this.resizeHandler = this.resizeHandler.bind(this);

        this.btn.addEventListener('click', this.btnClickHandler);
        window.addEventListener('resize', this.resizeHandler);
    }

    destroy() {
        console.log('Header.destroy');
        this.btn.removeEventListener('click', this.btnClickHandler);
        window.removeEventListener('resize', this.resizeHandler);
    }

    openSubnavi() {
        console.log('Header.openSubnavi');
        this.root.classList.add('has-mobile-subnavigation');
    }

    closeSubnavi() {
        console.log('Header.closeSubnavi');
        this.root.classList.remove('has-mobile-subnavigation');
        this.hasMobileSubnavigation = false;
    }

    btnClickHandler(event) {
        console.log('Header.btnClickHandler', event);
        this.hasMobileSubnavigation = !this.hasMobileSubnavigation;
        if(this.hasMobileSubnavigation === true) {
            this.openSubnavi();
        } else {
            this.closeSubnavi();
        }
    }

    resizeHandler() {
        //console.log('Header.handleResize', event, window.innerWidth, window.innerHeight);
        this.closeSubnavi();
    }
}

Header.instance;
Header.init = function() {
    console.log('Header.init');
    Header.instance = new Header();
};

Header.onDispose = function() {
    console.log('Header.onDispose');
    Header.instance.destroy();
    Header.instance = null;
};

export default Header;

if (module.hot) {
    module.hot.dispose(Header.onDispose);
}
